
export default {
    getData() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: 'https://www.artbook.top/apps/oss-h5/php/get.php',
                methods: 'get',
                dataType: 'json',
                success: function (res) {
                    var formData = new FormData();
                    var data = {
                        'key': res['dir'],
                        'policy': res['policy'],
                        'OSSAccessKeyId': res['accessid'],
                        'success_action_status': 200,
                        'callback': res['callback'],
                        'signature': res['signature'],
                    }
                    // formData.append('key', res['dir']);
                    formData.append('policy', res['policy']);
                    formData.append('OSSAccessKeyId', res['accessid']);
                    formData.append('success_action_status', 200);
                    formData.append('callback', res['callback']);
                    formData.append('signature', res['signature']);
                    resolve({ formData: data, url: res['host'], domain: res['domain'], formData1: formData })
                },
                error: function (error) {
                    reject(false)
                }
            })
        })
    },
    uploadImg(file) {
        let that = this
        return new Promise(function (resolve, reject) {
            that.getData().then(res => {
                if (res.formData1) {
                    let key = res.formData.key + that.random_string(20) + that.get_suffix(file.name)
                    res.formData1.append('key', key)
                    res.formData1.append('file', file)
                    $.ajax({
                        url: res.url,
                        type: 'post',
                        data: res.formData1,
                        contentType: false,
                        processData: false,
                        success: function () {
                            let file_path = res.domain + key;
                            let file_name = file.name;
                            let returnData = {
                                file_path: file_path,
                                file_name: file_name,
                                file_type: file.type
                            }
                            resolve(returnData)
                        },
                        error: function () {
                            reject()
                        }
                    })
                } else {
                    reject()
                }
            })
        })

    },
    get_suffix(filename) {

        var pos = filename.lastIndexOf(".");
        var suffix = "";
        if (pos != -1) {
          suffix = filename.substring(pos);
        }
        return suffix;
    },
    random_string(len) {
        var len = len || 32;
        var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
        var maxPos = chars.length;
        var pwd = "";
        for (var i = 0; i < len; i++) {
          pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }


}






